import { defineStore } from 'pinia';
import { useNotifications } from '~packages/epk-front-shared/lib';

export const useNotificationStore = defineStore('notifications', () => {
  const {
    notifications,
    createNotification,
    removeNotifications,
    stopBodyOverflow,
    allowBodyOverflow,
  } = useNotifications();

  const notifyError = (message: string, cfg = {}) =>
    createNotification({ type: 'error', message, ...cfg });
  const notifySuccess = (message: string, cfg = {}) =>
    createNotification({ type: 'success', message, ...cfg });

  return {
    notifications,
    notifyError,
    notifySuccess,
    removeNotifications,
    stopBodyOverflow,
    allowBodyOverflow,
  };
});
